export default __webpack_public_path__ + "assets/cc4287495fe3f5eefe8fc910ee19f768.png";